var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { guidFor } from '@ember/object/internals';
import { tracked } from '@glimmer/tracking';
import { load as cacheImage } from '../helpers/image';
import { isUrl } from './../helpers/is-url';
let UploadManager = (_class = class UploadManager {
  constructor(config) {
    _defineProperty(this, "config", void 0);
    _initializerDefineProperty(this, "uploadsInProgress", _descriptor, this);
    _defineProperty(this, "guidMap", void 0);
    if (!config.upload) {
      throw new Error('');
    }
    this.config = config;
    this.uploadsInProgress = [];
    this.guidMap = {};
  }
  async uploadFile(file) {
    this.guidMap[guidFor(file)] = file;
    return await this.doUpload(file);
  }
  async uploadFileFromUrl(url) {
    this.guidMap[guidFor(url)] = url;
    return await this.doUploadFromUrl(url);
  }
  async retryUpload(fileGUID) {
    let fileData = this.guidMap[fileGUID];
    if (typeof fileData === 'string' && isUrl(fileData)) {
      return await this.doUploadFromUrl(fileData);
    } else if (fileData) {
      return await this.doUpload(fileData);
    }
    return null;
  }
  async doUpload(file) {
    let result;
    if (this.config.upload) {
      let FileUploader = this.config.upload.uploader;
      let uploader = new FileUploader(file, this.config.upload.attrs);
      result = await this.doUploadHelper(uploader, this.config.upload, guidFor(file));
    }
    if (result) {
      return result;
    } else {
      return {
        type: 'failure',
        file,
        reason: 'not configured',
        //eslint-disable-line
        retryable: false
      };
    }
  }
  async doUploadFromUrl(url) {
    let result;
    let mockFile = new File([''], 'mockFile.txt');
    if (this.config.upload) {
      let FileUploader = this.config.upload.uploader;
      let attrs = {
        ...this.config.upload.attrs,
        url
      };
      let uploader = new FileUploader(mockFile, attrs);
      result = await this.doUploadHelper(uploader, this.config.upload, guidFor(url));
    }
    if (result) {
      return result;
    } else {
      return {
        type: 'failure',
        file: mockFile,
        reason: 'not configured',
        //eslint-disable-line
        retryable: false,
        url
      };
    }
  }
  async doUploadHelper(uploader, uploadConfig, guid) {
    if (this.uploadsInProgress.length === 0 && uploadConfig.onUploadStart) {
      uploadConfig.onUploadStart();
    }
    this.uploadsInProgress.push(uploader);
    /* eslint-disable-next-line no-self-assign */
    this.uploadsInProgress = this.uploadsInProgress;
    let result = await uploader.upload();
    if (result.type === 'success') {
      await cacheImage(result.uploadUrl);
      delete this.guidMap[guid];
    }
    this.uploadsInProgress.splice(this.uploadsInProgress.indexOf(uploader), 1);
    /* eslint-disable-next-line no-self-assign */
    this.uploadsInProgress = this.uploadsInProgress;
    if (this.uploadsInProgress.length === 0 && uploadConfig.onUploadFinish) {
      uploadConfig.onUploadFinish();
    }
    return result;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "uploadsInProgress", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { UploadManager as default };